import { render, staticRenderFns } from "./noticeUndone.vue?vue&type=template&id=6e71baa9"
import script from "./noticeUndone.vue?vue&type=script&lang=js"
export * from "./noticeUndone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e71baa9')) {
      api.createRecord('6e71baa9', component.options)
    } else {
      api.reload('6e71baa9', component.options)
    }
    module.hot.accept("./noticeUndone.vue?vue&type=template&id=6e71baa9", function () {
      api.rerender('6e71baa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/components/noticeUndone.vue"
export default component.exports